import { useQuery } from '@apollo/client';
import posthog from 'posthog-js';
import * as FullStory from '@fullstory/browser';
import { useEffect } from 'react';
import { CurrentUserQuery } from '../queries';

const Identify = () => {
  const { data: user } = useQuery(CurrentUserQuery, {
    context: { priorityOp: true },
  });
  const {
    encryptedUserId,
    email,
    firstName,
    lastName,
    hasValidSubscription,
    superadminRole,
  } = user?.me || {};
  const name = firstName && lastName && `${firstName} ${lastName}`;

  // Identify user for analytics
  useEffect(() => {
    if (encryptedUserId) {
      const properties = {
        email,
        displayName: name,
        hasValidSubscription,
        isSuperadmin: superadminRole,
      };

      posthog.identify(encryptedUserId, properties);
      FullStory.identify(encryptedUserId, properties); // TODO: remove this once we're no longer using FullStory
    }
    // Only call identify once per user session.
  }, [encryptedUserId]); // eslint-disable-line react-hooks/exhaustive-deps

  // Identify users in Intercom
  useEffect(() => {
    if (window.Intercom && (email || name)) {
      window.Intercom('update', {
        email,
        name,
        subscribed: hasValidSubscription,
        isSuperadmin: superadminRole,
      });
    }
  }, [email, hasValidSubscription, name, superadminRole]);

  return null;
};

export default Identify;
